import { getApiClient } from '@src/services/api-client'
import { useMutation } from '@tanstack/react-query'

export interface CalculatorSimulatePrequalificationRequestDto {
  ersScore: number
  financingProgramId: string
  provinceIso: string
  hasCoApplicant: boolean
  merchantId: string
  requestedLoanAmount: number
  applicantAnnualIncome?: number | null
  coApplicantAnnualIncome?: number | null
}

export interface CalculatorSimulatePrequalificationResultDto {
  decision: string
  maxLoanAmount: number
  maxLoanTerm: number
  minInterestRate: number
  maxInterestRate: number
  refusalReasonCodes: string[]
  warningCodes: string[]
}

const simulatePrequalification = async (
  request: CalculatorSimulatePrequalificationRequestDto,
): Promise<CalculatorSimulatePrequalificationResultDto> => {
  const response = await getApiClient().post<CalculatorSimulatePrequalificationResultDto>(
    '/Applications/Calculator/SimulatePrequalification',
    request,
  )
  return response.data
}

export const useCalculatorSimulatePrequalification = () =>
  useMutation({
    mutationFn: simulatePrequalification,
  })
